import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  position: absolute;
  cursor: pointer;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding: 0 3px;
  width: 20px;
  height: 22px;
  box-sizing: border-box;
  background-color: rgba(255, 156, 219, 0.4); /* Light pink background */
  margin: 5px;
  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  border: 1px solid purple;

  &.audio {
  }

  &.hud {
  }

  &::after {
    content: '';
    background-color: var(--green-200);
    border: 1px solid var(--green-900);
    border-radius: 3px;
    position: absolute;
    left: 2px;
    right: 2px;
    top: 6px;
    bottom: 6px;
  }

  &.selected {
    &&:after {
      background-color: var(--green-300);
      border: 1px solid yellowgreen;
    }
  }

  &:last-child {
  }

  &:hover {
  }

  &.dancing {
    animation: dance 1s 1 ease-in-out;

    // animation

    @keyframes dance {
      0% {
        transform: scale(1) rotate(0deg);
        box-shadow: 0 0 0px rgba(255, 182, 193, 0.5); /* Soft pink glow */
        background-color: rgba(255, 182, 193, 0.4); /* Light pink */
      }
      25% {
        transform: scale(1.1) rotate(10deg); /* Slight wobble clockwise */
        box-shadow: 0 0 20px rgba(255, 105, 180, 1); /* Bright pink glow */
        background-color: rgba(255, 105, 180, 0.6); /* Hot pink */
      }
      50% {
        transform: scale(1.1) rotate(-10deg); /* Slight wobble counterclockwise */
        box-shadow: 0 0 40px rgba(186, 85, 211, 0.8); /* Purple glow */
        background-color: rgba(186, 85, 211, 0.8); /* Medium Orchid */
      }
      75% {
        transform: scale(1.1) rotate(10deg); /* Wobble back clockwise */
        box-shadow: 0 0 30px rgba(255, 255, 255, 0.9); /* White glow */
        background-color: rgba(255, 182, 193, 0.6); /* Light pink */
      }
      100% {
        transform: scale(1) rotate(0deg); /* Return to original */
        box-shadow: 0 0 0px rgba(255, 182, 193, 0.5); /* Back to soft pink */
        background-color: rgba(255, 182, 193, 0.6); /* Light pink */
      }
    }
  }
`;

export const Handler = styled.div`
  width: 10px;
  height: 10px;
  background-color: var(--green-900);
  border-radius: 3px;
  cursor: pointer;
  z-index: 4;
  margin: 2px;

  &:hover {
    background-color: var(--green-800);
  }
`;
